import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@babackapp/customer-ui/components/alert";
import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
  ShopLogo,
} from "@babackapp/customer-ui/components/header";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputGroupText,
} from "@babackapp/customer-ui/components/input-group";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import {
  ArchiveXIcon,
  AtSignIcon,
  BoxIcon,
  LoaderIcon,
  SearchIcon,
} from "lucide-react";
import { Controller } from "react-hook-form";
import { useOrderIdentificationForm } from "../hooks/use-order-identification-form";

export function ReturnWidgetOrderIdentification() {
  const { form, mutation, onSubmit, logoUrl, isMerchant } = useOrderIdentificationForm();

  return (
    <WidgetPage variant="centered">
      <Header>
        <ShopLogo src={logoUrl ?? undefined} />
        <HeaderTitle>Demande de rétractation</HeaderTitle>
        <HeaderDescription>
          Renseignez les informations de commande afin de démarrer la demande de
          rétractation
        </HeaderDescription>
      </Header>

      {mutation.error && (
        <Alert variant="destructive">
          <ArchiveXIcon />
          <AlertTitle>Commande non trouvée</AlertTitle>
          <AlertDescription>
            Nous n'avons pas pu trouver votre commande. Veuillez vérifier le
            numéro de commande et réessayer.
          </AlertDescription>
        </Alert>
      )}

      <form className="flex flex-col gap-4" onSubmit={onSubmit}>
        <Controller
          control={form.control}
          name="orderName"
          render={({ field }) => (
            <InputGroup className="h-auto">
              <InputGroupInput placeholder="WEB-XT0000" {...field} />
              <InputGroupAddon align="block-start">
                <InputGroupText>Numéro de commande</InputGroupText>
                <BoxIcon />
              </InputGroupAddon>
            </InputGroup>
          )}
        />
        {!isMerchant && (
          <Controller
            control={form.control}
            name="secondaryInput"
            render={({ field }) => (
              <InputGroup className="h-auto">
                <InputGroupInput placeholder="email@example.com" {...field} />
                <InputGroupAddon align="block-start">
                  <InputGroupText>E-mail de la commande</InputGroupText>
                  <AtSignIcon />
                </InputGroupAddon>
              </InputGroup>
            )}
          />
        )}
        <AnimatedButtonRow variants={{}}>
          <AnimatedButtonContainer
            layoutId="line-item-confirm-button"
            variants={{}}
          >
            <Button type="submit" disabled={mutation.isPending}>
              {mutation.isPending ? (
                <LoaderIcon className="animate-spin" />
              ) : (
                <>
                  <SearchIcon />
                  Trouver ma commande
                </>
              )}
            </Button>
          </AnimatedButtonContainer>
        </AnimatedButtonRow>
      </form>
    </WidgetPage>
  );
}
